<template>
  <div id="sad-windows" :style="{backgroundPosition: 'center ' + offset * -0.8 + 'px', cursor: loading ? 'progress' : 'auto' }">
    <div>
      <div class="apollo" :style="{bottom: offset * 0.4 + 'px'}"></div>
      <div class="cherry-blossoms" :style="{backgroundPosition: 'left ' + offset * -0.6 + 'px'}"></div>
    </div>

    <div class="navbar">
      <a v-for="work in works" class="shortcut" v-show="work.show" :key="work.id" @click="openWindow(work.id)">
        <img :src="work.icon" alt="work.title" class="icon">
        <span class="subtext">{{ work.title }}</span>
      </a>
    </div>
    <Window v-for="work in works" :key="work.id" :work="work" v-if="work.open" @getFocus="getFocus($event)" @closeWindow="closeWindow($event)" @click.native="!isDesktop ? closeWindow(work.id) : 0" />
  </div>
</template>

<script>
import Window from '../window/Window.vue'

export default {
  components: {
    Window: Window
  },
  data () {
    return {
      works: [
        {
          id: 0,
          title: 'Escape',
          icon: '/src/assets/escape/icon.png',
          image: '/src/assets/escape/escape.jpg',
          show: false,
          open: false,
          hasFocus: false
        },
        {
          id: 1,
          title: 'Blinded',
          icon: '/src/assets/blinded/icon.png',
          image: '/src/assets/blinded/blinded.png',
          bgColor: '#D8CB94',
          show: false,
          open: false,
          hasFocus: false
        },
        {
          id: 2,
          title: 'Pyramid',
          icon: '/src/assets/pyramid/icon.png',
          image: '/src/assets/pyramid/pyramid.png',
          bgColor: '#5D537B',
          show: false,
          open: false,
          hasFocus: false
        },
        {
          id: 3,
          title: 'Geometry Class',
          icon: '/src/assets/geometry/icon.png',
          image: '/src/assets/geometry/geometry.jpg',
          show: false,
          open: false,
          hasFocus: false
        },
        {
          id: 4,
          title: 'The New Genesis',
          icon: '/src/assets/genesis/icon.png',
          image: '/src/assets/genesis/genesis.jpg',
          show: false,
          open: false,
          hasFocus: false
        },
        {
          id: 5,
          title: '?',
          icon: '/src/assets/alheak/icon.png',
          link: 'https://alheak-portfolio.web.app/',
          show: false,
          open: false,
          hasFocus: false
        },
        {
          id: 6,
          title: 'Contact',
          icon: '/src/assets/misc/contact.png',
          content: 'contact',
          show: false,
          open: false,
          hasFocus: false
        }
      ],
      offset: 0,
      loading: false,
      which: null
    }
  },
  computed: {
    isDesktop () {
      return window.innerWidth > 1280 ? true : false
    }
  },
  methods: {
    setOffset () {
      this.offset = this.isDesktop ? window.innerHeight - window.pageYOffset : 0

      if(window.pageYOffset >= window.innerHeight - 100) {
        this.showIcons()
      }
    },
    showIcons () {
      const worksLength = this.works.length
      this.loading = true

      this.works.forEach((work, i) => {
        setTimeout(() => {
          work.show = true

          if(i + 1 === worksLength) {
            this.loading = false
          }
        }, (Math.random() + 1) * 1000 + (500 * i))
      })
    },
    openWindow (which) {
      this.works[which].open = true

      this.getFocus(which)
    },
    getFocus (which) {
      this.works.forEach((work, i) => {
        work.id === which ? this.works[i].hasFocus = true : this.works[i].hasFocus = false
      })
    },
    closeWindow (which) {
      this.works[which].open = false
    }
  },
  beforeMount () {
    this.setOffset()
  },
  mounted () {
    window.addEventListener("scroll", () => {
      this.setOffset()
    })
  }
}
</script>

<style>
#sad-windows {
  position: absolute;
  top: 100vh;
  background-image: url('sw-back.jpg');
  background-size: cover;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.effects {
  animation: crtEffect 0.03s infinite alternate;
}

.cherry-blossoms {
  position: absolute;
  background-image: url('cherry-blossoms.png');
  background-repeat: no-repeat;
  background-size: contain;
  width: 100vw;
  height: 100vh;
}

.apollo {
  position: absolute;
  background-image: url('apollo.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right bottom;
  bottom: 0;
  width: 100vw;
  height: 80vh;
}

.navbar {
  position: absolute;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 275px;
  height: 100vh;
  text-align: center;
}

.shortcut {
  position: relative;
  display: block;
  width: 100px;
  margin: 25px 0 0 25px;
  text-decoration: none;
  cursor: pointer;
}

.shortcut:after {
  position: absolute;
  top: 78px;
  left: 0;
  display: block;
  content: '';
  width: 22px;
  height: 22px;
  background-image: url('./shortcut-arrow.png');
  background-size: contain;
}

.icon {
  display: block;
  width: 100px;
  height: 100px;
  margin-bottom: 6px;
  -webkit-filter: drop-shadow(2px 2px 2px #343238);
  filter: drop-shadow(2px 2px 2px #343238);
}

.subtext {
  width: 100px;
  background-color: #09A;
  color: #FFF;
}

@media (orientation: portrait) {
  .cherry-blossoms {
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/assets/sad windows/SadWindows.vue